import { type MCPServerInfo } from '../../types';

const AwsIamServer: MCPServerInfo = {
  serverId: 'AWS_IAM',
  name: 'AWS IAM',
  slug: 'aws-iam',
  description: 'AWS IAM MCP Server',
  source: {
    sourceType: 'REPOSITORY',
    type: 'OFFICIAL',
    repositoryUrl:
      'mcp/public.ecr.aws/awslabs-mcp/awslabs/iam-mcp-server:sha-00083602a8f70cb8e5b833fa84a8de11b96d8be9',
    commitSha: '5d04a96',
    packageType: 'npm',
    packageName: ''
  },
  authenticationType: 'STATIC_CREDS',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [
      'awsAccessKeyId',
      'awsRegion',
      'awsSecretAccessKey',
      'awsSessionToken'
    ],
    properties: {
      awsAccessKeyId: {
        type: 'string',
        description: 'AwsAccessKey ID',
        sensitive: true
      },
      awsRegion: {
        type: 'string',
        description: 'AwsRegion',
        sensitive: false
      },
      awsSecretAccessKey: {
        type: 'string',
        description: 'AwsSecretAccessKey',
        sensitive: true
      },
      awsSessionToken: {
        type: 'string',
        description: 'AwsSessionToken',
        sensitive: true
      },
      fastmcpLogLevel: {
        type: 'string',
        description: 'FastmcpLogLevel',
        sensitive: false,
        default: 'INFO'
      }
    }
  }
};

export default AwsIamServer;
